import AddHomeScreen from './component'

export default AddHomeScreen